import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { MODAL_TYPE_DEMO_MODE } from '../../constants/modal-types';
import { openModal } from '../../actions/open-modal';
import Button from '../button';
import requestLogin from '../../services/request-login';
import withTranslate from '../../hoc/with-translate';
import styles from '../button/button.scss';

class LoginButton extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount() {
    if (this.props.autoLogin) {
      setTimeout(() => this.handleClick(), 100);
    }
  }

  handleClick() {
    const { onLogin, onLoginError, viewMode, isDemoMode, openModal } = this.props;

    if (isDemoMode) {
      openModal(MODAL_TYPE_DEMO_MODE, { viewMode });
    } else {
      requestLogin(memberDetails => {
        if (memberDetails) {
          onLogin(memberDetails.data || memberDetails);
        } else {
          onLoginError();
        }
      });
    }
  }

  render() {
    const { t } = this.props;
    return (
      <Button className={classNames(styles.button, 'login-button')} onClick={this.handleClick}>
        {t('login-button.sign-up')}
      </Button>
    );
  }
}

LoginButton.propTypes = {
  autoLogin: PropTypes.bool,
  onLogin: PropTypes.func.isRequired,
  onLoginError: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  viewMode: PropTypes.string.isRequired,
  isDemoMode: PropTypes.bool,
  openModal: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  viewMode: state.viewMode,
  isDemoMode: state.isDemoMode,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      openModal,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(withTranslate(LoginButton));



// WEBPACK FOOTER //
// ./app/components/login-button/login-button.js